import React from 'react'
import styles from './BestPractice.module.scss'

interface Props {
  contents: {
    heading: string[]
    text: string[]
  }
}

const BestPractice: React.FC<Props> = ({ contents }) => {
  const headingBr = contents.heading.map((text, index) => (
    <React.Fragment key={index}>
      {text}
      {index < contents.heading.length - 1 && <br />}
    </React.Fragment>
  ))

  const descriptionBr = contents.text.map((text, index) => (
    <React.Fragment key={index}>
      {text}
      {index < contents.heading.length - 1 && <br />}
    </React.Fragment>
  ))

  return (
    <>
      <div className={styles.best_practice_section}>
        <div className={styles.best_practice_wrapper}>
          <h2>{headingBr}</h2>
          <p>{descriptionBr}</p>
        </div>
      </div>
    </>
  )
}
export default BestPractice
